/**
 * Authentication constants and validation rules
 */

// Field lengths
export const FIELD_LENGTHS = {
  COMPANY_CODE: {
    MIN: 1,
    MAX: 10,
  },
  USER_ID: {
    MIN: 1,
    MAX: 20,
  },
  PASSWORD: {
    MIN: 1,
    MAX: 100,
  },
} as const;

// Validation messages
export const VALIDATION_MESSAGES = {
  COMPANY_CODE: {
    REQUIRED: 'Company code is required',
    MIN: `Company code must be at least ${FIELD_LENGTHS.COMPANY_CODE.MIN} characters`,
    MAX: `Company code must not exceed ${FIELD_LENGTHS.COMPANY_CODE.MAX} characters`,
    INVALID: 'Invalid company code format',
  },
  USER_ID: {
    REQUIRED: 'User ID is required',
    MIN: `User ID must be at least ${FIELD_LENGTHS.USER_ID.MIN} characters`,
    MAX: `User ID must not exceed ${FIELD_LENGTHS.USER_ID.MAX} characters`,
    INVALID: 'Invalid user ID format',
  },
  PASSWORD: {
    REQUIRED: 'Password is required',
    MIN: `Password must be at least ${FIELD_LENGTHS.PASSWORD.MIN} characters`,
    MAX: `Password must not exceed ${FIELD_LENGTHS.PASSWORD.MAX} characters`,
  },
  API: {
    LOGIN_FAILED:
      'Invalid credentials. Please check your information and try again.',
    NETWORK_ERROR:
      'No internet connection. Please check your network and try again.',
    SERVER_ERROR: 'Server error. Please try again later.',
    UNKNOWN_ERROR: 'An unexpected error occurred. Please try again.',
  },
} as const;

// Redirect URLs
export const REDIRECT_URLS = {
  DEFAULT_AFTER_LOGIN: '/',
  LOGIN_PAGE: '/login',
} as const;

// UI text
export const UI_TEXT = {
  TITLE: 'STX Hub System',
  SUBTITLE: 'Sign in to access your account',
  SUBMIT_BUTTON: 'Sign In',
  SUBMITTING_BUTTON: 'Signing in...',
  FORGOT_PASSWORD: 'Forgot password?',
  COMPANY_CODE_LABEL: 'Company Code',
  USER_ID_LABEL: 'User ID',
  PASSWORD_LABEL: 'Password',
  REMEMBER_ME: 'Remember me',
  SSO: {
    DIVIDER: 'Or continue with',
    BUTTON_TEXT: 'Sign in with OneLogin SSO',
    REDIRECTING: 'Redirecting to OneLogin...',
    ERROR_TITLE: 'SSO Login Error',
    ERROR_MESSAGE: 'Failed to initiate SSO login. Please try again.',
    CALLBACK: {
      PROCESSING_TITLE: 'Completing SSO Authentication...',
      PROCESSING_SUBTITLE: 'Please wait while we verify your credentials',
      ERROR_TITLE: 'Authentication Failed',
      ERROR_SUBTITLE: 'Redirecting to login page...',
      SUCCESS_TITLE: 'Login Successful',
      SUCCESS_MESSAGE: 'Welcome! Redirecting to dashboard...',
    },
  },
} as const;
